import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPhoneFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.0558 21.8804C12.8626 20.974 9.84968 19.2637 7.33804 16.752C4.82641 14.2404 3.11606 11.2275 2.20972 8.03424C2.20435 8.01531 2.19902 7.99654 2.19373 7.97793C2.04622 7.45891 1.93183 7.05644 1.93019 6.50455C1.92831 5.87378 2.13382 5.08354 2.44275 4.53359C2.97403 3.58782 4.11479 2.37577 5.10012 1.8774C5.95146 1.44679 6.95686 1.44679 7.8082 1.8774C8.65044 2.3034 9.58843 3.25696 10.1113 4.06122C10.7578 5.05556 10.7578 6.33743 10.1113 7.33176C9.9381 7.59821 9.69117 7.84473 9.40451 8.1309C9.31525 8.22001 9.217 8.2844 9.28225 8.42029C9.93007 9.76957 10.8136 11.0352 11.9342 12.1558C13.0549 13.2765 14.3205 14.16 15.6698 14.8078C15.8105 14.8754 15.8659 14.779 15.9592 14.6856C16.2454 14.3989 16.4919 14.152 16.7583 13.9787C17.7527 13.3322 19.0345 13.3322 20.0289 13.9787C20.8116 14.4877 21.79 15.4462 22.2127 16.2819C22.6433 17.1332 22.6433 18.1386 22.2127 18.99C21.7143 19.9753 20.5023 21.116 19.5565 21.6473C19.0065 21.9563 18.2163 22.1618 17.5855 22.1599C17.0336 22.1582 16.6312 22.0439 16.1122 21.8964C16.0935 21.8911 16.0748 21.8857 16.0558 21.8804Z",
		fill: "currentColor"
	})
});
export default SvgPhoneFilled;
